import { useEffect } from "react";
import { motion } from "framer-motion";
import { CalendarCheck } from "@phosphor-icons/react";
import { useLanguage } from "../i18n";

const CALENDLY_URL =
  "https://calendly.com/luca-pedano/30min?hide_gdpr_banner=1&background_color=050709&text_color=ffffff&primary_color=00f0ff";

export const Booking = () => {
  const { t } = useLanguage();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="booking" data-testid="booking-section" className="relative py-28 md:py-40 overflow-hidden bg-ink-soft">
      <span className="absolute -top-8 right-4 md:right-10 font-display font-bold text-[26vw] md:text-[18rem] leading-none text-white/[0.03] select-none pointer-events-none" aria-hidden="true">
        05
      </span>
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-brand-cyan mb-6"
          data-testid="booking-chapter-label"
        >
          {t.chapters.booking}
        </motion.p>

        <div className="max-w-2xl mb-14">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="flex items-center gap-4 font-display font-semibold tracking-tight text-4xl md:text-5xl leading-[1.05]"
            data-testid="booking-title"
          >
            <CalendarCheck size={40} weight="duotone" className="text-brand-cyan shrink-0" />
            {t.booking.title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="mt-5 font-mono text-sm text-white/50 leading-relaxed"
            data-testid="booking-subtitle"
          >
            {t.booking.sub}
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="rounded-lg border border-brand-cyan/20 bg-ink p-2 md:p-4 shadow-[0_0_60px_-15px_rgba(0,240,255,0.2)]"
          data-testid="booking-widget-wrapper"
        >
          <div
            className="calendly-inline-widget w-full rounded-lg overflow-hidden"
            data-url={CALENDLY_URL}
            style={{ minWidth: "320px", height: "700px" }}
            data-testid="calendly-widget"
          />
          <p className="sr-only">{t.booking.fallback}</p>
        </motion.div>
      </div>
    </section>
  );
};
